module.exports = __webpack_public_path__ + "static/media/img-e-cards.0a7a1db9.jpg";